import { Injectable } from '@angular/core';

import { CammsCryptoService } from 'projects/camms-crypto/src/public-api';

@Injectable({
    providedIn: 'root',
})
export class CammsClientStorageService {
    constructor(private crypto: CammsCryptoService) {}

    setData(key: string, data: any) {
        const encryptedData = this.crypto.encryptData(data);
        localStorage.setItem(key, encryptedData);
    }

    getData(key: string) {
        const encryptedData = localStorage.getItem(key);
        if (encryptedData) {
            const plainText = this.crypto.decryptData(encryptedData);
            return plainText;
        }

        return;
    }

    getEncryptedData(key: string) {
        return localStorage.getItem(key);
    }

    clearData(key: string) {
        localStorage.removeItem(key);
    }

    clearLocalStorage() {
        localStorage.clear();
    }

    getEncryptedValue(value: string) {
        return this.crypto.encryptData(value);
    }

    getDecryptedValue(encryptedData: any) {
        let plainText = this.crypto.decryptData(encryptedData);
        plainText = plainText?.replaceAll('"', '');
        return plainText;
    }

    getSanitizedData(key: string) {
        var value = this.getData(key);
        if (!value) { return ''; }
        
        return value.replace(/"/g, '');
      }
}
